"use strict";

const IncidentEnforcementController = require("./incidentEnforcementController");
const BaseEnforcementLetterManagement = require("../../enforcement/baseEnforcementLetterManagement");

const EnforcementLetterManagement = function () {
  const base = BaseEnforcementLetterManagement(IncidentEnforcementController);

  return {
    ...base,
  };
};

module.exports = EnforcementLetterManagement();
